import ReactPaginate from 'react-paginate'
import { useSelector, useDispatch } from 'react-redux'
import qs from 'qs'
import { itemsFetchData } from '../../redux/items'
import { parseSubjectsFromUrl } from '../../SearchUtils'

function Pagination() {
  const { total, currentFilters, searchPath } = useSelector(
    (state) => state.items
  )
  const dispatch = useDispatch()

  const handlePageChange = (page) => {
    const newFilters = { ...currentFilters }

    newFilters.page = page.selected === 0 ? null : page.selected + 1
    newFilters.popstate = 0
    newFilters.subjects = parseSubjectsFromUrl()

    App.State.scrollToTop = true

    dispatch(itemsFetchData({ filters: newFilters }))
  }

  const buildHref = (page) => {
    const newFilters = { ...currentFilters }

    delete newFilters.page

    if (page && page > 1) {
      newFilters.page = page
    }

    let searchPathLocal = ''
    if (Object.keys(newFilters).length > 0) {
      searchPathLocal = `?${qs.stringify(newFilters, {
        arrayFormat: 'brackets',
      })}`
    }

    return `${searchPath}${searchPathLocal}`
  }

  return (
    <nav aria-label="Car result pagination">
      <ReactPaginate
        previousLabel={<i className="fas fa-chevron-left" />}
        nextLabel={<i className="fas fa-chevron-right" />}
        activeClassName="active"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        pageCount={Math.ceil(total / 40)}
        pageRangeDisplayed={4}
        marginPagesDisplayed={2}
        forcePage={(currentFilters.page || 1) - 1}
        containerClassName="pagination justify-content-center"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        disabledClassName="disabled"
        onPageChange={handlePageChange}
        hrefBuilder={(page) => buildHref(page)}
        ariaLabelBuilder={(page) => `Page ${page}`}
      />
    </nav>
  )
}

export default Pagination
